<template>
  <div class="k-editable-date-picker">
    <div v-if="edit">
      <k-date-picker
        v-model="date"
        :timezone="timezone"
      ></k-date-picker>
      <k-icon-button :icon="'fas fa-check'" :aria-label="'Save'" class="save" title="Save Icon" @click="saveDate()"></k-icon-button>
      <k-icon-button :icon="'fas fa-xmark'" :aria-label="'Cancel'" class="cancel" title="Cancel Icon"  @click="edit = false"></k-icon-button>
    </div>
    <div v-else>
      {{ parseTimestamp(modelValue, customFormat, customMask, timezone) }}
      <k-icon-button :icon="'fas fa-edit'" :aria-label="'Edit'" class="edit" title="Edit Icon" @click="edit = true"></k-icon-button>
    </div>
  </div>
</template>

<style scoped>
.k-editable-date-picker > div {
  display: flex;
}

.save {
  color: var(--kate-success);
}

.cancel {
  color: var(--kate-danger);
}
</style>

<script>
import TimeMixins from '@mixins/time-mixins';
import KDatePicker from './k-date-picker.vue';
import KIconButton from './buttons/k-icon-button.vue';

export default {
  components: { KIconButton, KDatePicker },
  mixins: [TimeMixins],
  name: 'k-editable-date-picker',
  props: {
    modelValue: {
      type: [Date, String],
      required: false,
    },
    timezone: {
      type: String,
      default: 'Europe/London',
    },
    customMask: {
      type: String,
      default: 'MMM d, yyyy',
    },
    customFormat: {
      type: String,
      default: undefined,
    },
  },

  mounted() {
    this.date = this.modelValue;
  },

  data() {
    return {
      edit: false,
      date: null,
    };
  },

  methods: {
    saveDate() {
      this.$emit('update:modelValue', this.date);
      this.$emit('change');
      this.edit = false;
    },
  },
};
</script>
